import React from 'react';
import './HomeBanner.scss';

import ResourceCenter from '../resourceCenter/ResourceCenter';
import InTheNews from '../inTheNews/InTheNews';
import SearchInput from '../search/Search';
import TopArticle from '../topArticle/TopArticle';

const HomeBanner: React.FC = () => {

    const [showFieldSelector, setShowFieldSelector] = React.useState(false);

    return (
        <>
            <div className="home-banner-container">
                <div className="banner-img"></div>

                <TopArticle />
                <div className="container data-container">
                    <SearchInput onInputFocus={() => setShowFieldSelector(true)} onInputBlur={() => setShowFieldSelector(false)} showFieldSelector={showFieldSelector} />
                    <ResourceCenter />
                    <InTheNews />
                </div>
            </div>
        </>
    );
};

export default HomeBanner;
